<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <el-select
      :value="value"
      :clearable="clearable"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      @change="$emit('input', $event)"
    >
      <el-option
        v-for="(item, index) in items"
        :key="index"
        :label="item.descricao"
        :value="Number(item.id)"
      >
      </el-option>
    </el-select>
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputSwitch",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {},
  data() {
    return {
      items: [
        {
          id: 1,
          descricao: "Sim",
        },
        {
          id: 0,
          descricao: "Não",
        },
      ],
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};
</script>


// WEBPACK FOOTER //
// EdInputSwitch.vue?096a67b8